import React from "react";

import { Col } from "reactstrap";
import Card, {
  CardPrimaryContent,
  CardMedia,
  CardActions,
  CardActionIcons
} from "@material/react-card";
import Button from "@material/react-button";
import MaterialIcon from "@material/react-material-icon";
import Slide from "react-reveal/Slide";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import { Resources } from "../../contexts/ResourcesContext";

class ProjectItem extends React.Component {
  static propTypes = {
    project: PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
      date: PropTypes.string,
      subtitle: PropTypes.string,
      description: PropTypes.string,
      video: PropTypes.string,
      organization: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.string),
      github: PropTypes.string,
      link: PropTypes.string,
      people: PropTypes.number
    }).isRequired,
    history: PropTypes.object
  };

  render() {
    const { project, history } = this.props;
    const link = `/p/${project.slug}`;

    return (
      <Col sm={6} md={4} lg={3} className={this.props.className}>
        <Slide bottom appear>
          <Card>
            <CardPrimaryContent
              onClick={() => {
                history.push(link);
              }}
            >
              <CardMedia
                imageUrl={
                  project.slug in Resources.images
                    ? Resources.images[project.slug]
                    : Resources.logos[project.slug]
                }
                wide
              />
              <div className="card-container">
                <h3>
                  {project.name}
                  <small>
                    {" "}
                    {project.organization && `@${project.organization}`}{" "}
                    <MaterialIcon icon="person" style={{ verticalAlign: -4 }} />
                    {project.people}
                  </small>
                </h3>
                <small>{project.subtitle}</small>
              </div>
            </CardPrimaryContent>

            <CardActions>
              {/*<CardActionButtons>*/}
              {project.link !== undefined && (
                <Button href={project.link} target="_blank">
                  <MaterialIcon icon="link" />
                </Button>
              )}
              {/*</CardActionButtons>*/}

              <CardActionIcons>
                <Link to={link}>
                  <Button raised>Infos</Button>
                </Link>
              </CardActionIcons>
            </CardActions>
          </Card>
        </Slide>
      </Col>
    );
  }
}

export default withRouter(ProjectItem);
